var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, MenuSection, MessageBanner, Pane, ConfirmationModal, ErrorModal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import NavComponent from "../../components/NavComponent";
import TableComponent from "../../components/TableComponent";
import TitleDetail from "./TitleDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useTitleFilters } from "../../hooks/useTitleFilters";
import { useTitleData } from "../../hooks/useTitleData";
import { useTitleActions } from "../../hooks/useTitleActions";
import { useTitleTable } from "../../hooks/useTitleTable";
import { useTableSort } from "../../hooks/useTableSort";
import { usePermissions } from "../../hooks/usePermissions";
import { useApiErrorMessageId } from "../../hooks/useApiErrorMessageId";
import { usePublishersData } from "../../hooks/usePublishersData";
import { usePageSize } from "../../hooks/usePageSize";
import { TitlesFilters } from "../../components/TitlesFilters";
import { CreateAnotherProductConfirmModal } from "../../components/title/CreateAnotherProductConfirmModal";
import { fetchCollectionById } from "../../api/collectionsService";
import { COLUMN_LAYOUT_KEYS } from "../../utils/constants";
import { formatCollectionName } from "../../utils/collectionDisplayUtils";
import { CurrentUserLoadErrorBanner } from "../../components/CurrentUserLoadErrorBanner";
var TitleList = function () {
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = useTitleFilters();
    var collectionFilterId = filtersHook.filters.collection;
    var filteredCollection = useQuery(["collection", collectionFilterId], function () { return fetchCollectionById(ky, collectionFilterId); }, { enabled: !!collectionFilterId }).data;
    var _b = useTableSort(), sort = _b.sort, handleHeaderClick = _b.handleHeaderClick;
    var _c = usePublishersData(filtersHook.publisherSearchQuery, filtersHook.filters.publisher), publishers = _c.publishers, publishersLoading = _c.publishersLoading, selectedPublisher = _c.selectedPublisher, selectedPublisherLoading = _c.selectedPublisherLoading;
    var _d = usePageSize(), pageSize = _d.pageSize, createPageSizeHandler = _d.createPageSizeHandler;
    var dataHook = useTitleData(filtersHook.filters, pageSize, selectedPublisher, sort, 
    // a search before the publisher is known would be thrown away
    filtersHook.filtersReady && !selectedPublisherLoading);
    var actionsHook = useTitleActions();
    var _e = usePermissions(), canEditTitleItem = _e.canEditTitleItem, canDeleteTitleItem = _e.canDeleteTitleItem, canCreateProduct = _e.canCreateProduct, canCreateProductForTitle = _e.canCreateProductForTitle, canCreateProductForTitleSearchItem = _e.canCreateProductForTitleSearchItem, canCreateTitle = _e.canCreateTitle, hasPublicOnlyView = _e.hasPublicOnlyView;
    var loadErrorMessageId = useApiErrorMessageId(dataHook.error, "ui-br-agency.title.list.loadError");
    var _f = useTitleTable(actionsHook.handleRowClick, canCreateProduct, canCreateProductForTitleSearchItem), columns = _f.columns, requestCreateProduct = _f.requestCreateProduct, createProductConfirmModalProps = _f.createProductConfirmModalProps;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleSortHeaderClick = function (columnId) {
        dataHook.resetPageOffset();
        handleHeaderClick(columnId);
    };
    var handleApplyFilters = function () {
        if (filtersHook.hasInvalidDateRange)
            return;
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var handleClearCollectionFilter = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearCollectionFilter();
    };
    var handleToggleCommentForAgencyFilter = function () {
        dataHook.resetPageOffset();
        filtersHook.handleToggleCommentForAgencyFilter();
    };
    var source = createStripesSource({
        ky: null,
        data: dataHook.titlesData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading || dataHook.isWaitingForFilters,
        isError: dataHook.isError,
        isLoaded: dataHook.isFetched,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
        failureMessage: formatMessage({ id: loadErrorMessageId }),
    });
    var hasAnyAction = actionsHook.selectedTitle
        ? canEditTitleItem(actionsHook.selectedTitle) ||
            canDeleteTitleItem(actionsHook.selectedTitle) ||
            canCreateProductForTitle(actionsHook.selectedTitle)
        : false;
    return (React.createElement(React.Fragment, null,
        actionsHook.isOpen && (React.createElement(ConfirmationModal, { open: actionsHook.isOpen, heading: formatMessage({
                id: "ui-br-agency.title.delete.modal.heading",
            }), message: actionsHook.message, onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, actionsHook.confirmDelete()];
                        case 1:
                            _a.sent();
                            dataHook.refetch();
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: actionsHook.closeModal, confirmLabel: formatMessage({ id: "ui-br-agency.button.delete" }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "primary" })),
        React.createElement(CreateAnotherProductConfirmModal, __assign({}, createProductConfirmModalProps)),
        actionsHook.errorOpen && (React.createElement(ErrorModal, { open: true, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: actionsHook.errorMessage, onClose: actionsHook.closeError })),
        React.createElement(RecekPaneSet, null,
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(TitlesFilters, { temporaryIdFilter: filtersHook.temporaryIdFilter, temporaryNameFilter: filtersHook.temporaryNameFilter, temporaryContributorFilter: filtersHook.temporaryContributorFilter, temporaryProductNumberFilter: filtersHook.temporaryProductNumberFilter, hasCommentForAgency: filtersHook.filters.hasCommentForAgency, temporaryDateRangeFilters: filtersHook.temporaryDateRangeFilters, hasInvalidDateRange: filtersHook.hasInvalidDateRange, dateInputs: filtersHook.dateInputs, onDateRangeFilterChange: filtersHook.setTemporaryDateRangeFilter, publishers: publishers, publishersLoading: publishersLoading, selectedPublisher: selectedPublisher, onIdFilterChange: filtersHook.setTemporaryIdFilter, onNameFilterChange: filtersHook.setTemporaryNameFilter, onContributorFilterChange: filtersHook.setTemporaryContributorFilter, onProductNumberFilterChange: filtersHook.setTemporaryProductNumberFilter, onPublisherFilterChange: filtersHook.handlePublisherSelection, onPublisherSearchInput: filtersHook.handlePublisherSearchInput, onToggleCommentForAgency: handleToggleCommentForAgencyFilter, showCommentForAgencyFilter: !hasPublicOnlyView, onApplyFilters: handleApplyFilters })))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.title.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: canCreateTitle
                    ? function (_a) {
                        var onToggle = _a.onToggle;
                        return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    onToggle();
                                    history.push("/bragency/titles/create");
                                } },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                    }
                    : undefined },
                dataHook.isError && !dataHook.isFetching && (React.createElement(MessageBanner, { type: "error" },
                    React.createElement(FormattedMessage, { id: loadErrorMessageId }))),
                collectionFilterId && (React.createElement(MessageBanner, { dismissible: true, onExited: handleClearCollectionFilter },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.filter.collection.active", values: {
                            name: (filteredCollection === null || filteredCollection === void 0 ? void 0 : filteredCollection.mainName)
                                ? formatCollectionName(filteredCollection)
                                : "…",
                        } }))),
                React.createElement(CurrentUserLoadErrorBanner, { show: filtersHook.currentUserLoadFailed }),
                React.createElement(TableComponent, { data: dataHook.titlesData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, sortedColumn: sort.column, sortDirection: sort.column ? sort.direction : undefined, onHeaderClick: handleSortHeaderClick, layoutKey: COLUMN_LAYOUT_KEYS.TITLES })),
            actionsHook.selectedTitle && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.title.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: hasAnyAction
                    ? function (_a) {
                        var onToggle = _a.onToggle;
                        var canEdit = canEditTitleItem(actionsHook.selectedTitle);
                        var canDelete = canDeleteTitleItem(actionsHook.selectedTitle);
                        var canCreate = canCreateProductForTitle(actionsHook.selectedTitle);
                        if (!canEdit && !canDelete && !canCreate)
                            return null;
                        return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                            canEdit && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    var _a;
                                    return history.push("/bragency/titles/edit/".concat((_a = actionsHook.selectedTitle) === null || _a === void 0 ? void 0 : _a.id));
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" }))),
                            canDelete && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    return actionsHook.openConfirm(actionsHook.selectedTitle);
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" }))),
                            canCreate && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
                                    // The detail pane renders the products panel, so
                                    // the product count is usually already cached.
                                    requestCreateProduct(actionsHook.selectedTitle.id);
                                }, fullWidth: true },
                                React.createElement(FormattedMessage, { id: "ui-br-agency.title.action.createProduct" })))));
                    }
                    : undefined },
                React.createElement(TitleDetail, { title: actionsHook.selectedTitle }))))));
};
export default TitleList;
